/* eslint-disable max-classes-per-file */
export class Photo {
  url: string = "";

  constructor(url: string) {
    this.url = url;
  }
}

export class Category {
  name: string = "";

  slug: string = "";

  constructor(data: any) {
    this.name = data?.name || "";
    this.slug = data?.slug || "";
  }
}

export class DetailExperienceRecentlyView {
  experienceId: number = 0;

  name: string = "";

  slug: string = "";

  areaName: string = "";

  areaSlug: string = "";

  cityName: string = "";

  citySlug: string = "";

  countryName: string = "";

  isGreenCertificate?: boolean;

  countrySlug: string = "";

  tier: string = "";

  ticketType: string = "";

  isExclusive: boolean = false;

  klubCategory: string = "";

  category: Category[] = [];

  prices: number = 0;

  isActive: number = 1;

  textRating: string = "";

  reviewRating: {
    rating: number;
    textRatingDetail: string;
    numReviews: number;
  };

  photo: Photo[] = [];

  createDate: string = "";

  constructor(data: any) {
    this.experienceId = data?.experienceId || 0;
    this.name = data?.name || "";
    this.slug = data?.slug || "";
    this.areaName = data?.areaName || "";
    this.areaSlug = data?.areaSlug || "";
    this.cityName = data?.cityName || "";
    this.citySlug = data?.citySlug || "";
    this.countryName = data?.countryName || "";
    this.countrySlug = data?.countrySlug || "";
    this.tier = data?.tier || "";
    this.ticketType = data?.ticketType || "";
    this.isExclusive = data?.isExclusive || false;
    this.klubCategory = data?.klubCategory || "";
    this.category = (data?.category || []).map((cat: any) => new Category(cat));
    this.prices = data?.prices || "";
    this.isActive = data?.isActive || 1;
    this.textRating = data?.textRating || "";
    this.reviewRating = {
      rating: data.reviewRating?.rating || 0,
      textRatingDetail: data.reviewRating?.textRatingDetail || "",
      numReviews: data.reviewRating?.numReviews || 0,
    };
    this.photo = (data?.photo || []).map((url: string) => new Photo(url));
    this.createDate = data?.createDate || "";
    this.isGreenCertificate = data?.isGreenCertificate || false;
  }
}

export class ExperienceRecentlyViewResponse {
  status: boolean = false;

  data: string = "";

  constructor(data: any) {
    this.status = data?.status || false;
    this.data = (data?.data || []).map(
      (value: any) => new DetailExperienceRecentlyView(value),
    );
  }
}
